module.exports = __webpack_public_path__ + "img/solution-background.c507b2cf.png";